module.exports = __webpack_public_path__ + "static/img/visit_card.fc3260cd.png";